import $ from 'jquery';

export default function(API) {
  
	if (API.cookie.get('kplussa_number') || API.cookie.get('loggedIn')) {
		$('.user-has-kplussa').removeClass('hidden');
	} else {
		$('.user-has-not-kplussa').removeClass('hidden');
	}
}
